import { Typography, Button, Box, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import React, { useEffect, useState, useRef } from 'react';
import ResponsiveAppBarAlt from './ResponsiveAppBarAlt';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const ScrollAnimation = () => {
  const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);
  const heroNavWrapperRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const screenHeight = window.innerHeight;


    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsHeroNavVisible(entry.isIntersecting);
                const navbar = document.querySelector(".navbar.alt");
                if (navbar) {
                    if (!entry.isIntersecting) {
                        navbar.style.marginTop = "0px";
                    } else {
                        navbar.style.marginTop = "-100px";
                    }
                }
            },
            { threshold: 0.01 }
    );

    if (heroNavWrapperRef.current) {
      observer.observe(heroNavWrapperRef.current);
    }

    return () => {
      if (heroNavWrapperRef.current) {
        observer.unobserve(heroNavWrapperRef.current);
      }
    };
  }, []);


  return (

    <div className="App">
<ResponsiveAppBarAlt />

<main>

  <Box className="heroWrapper subpage" id="start">

  <img src="Vereine.webp" className='herobackimg' />
    <Box className='heroWrapperLayer'></Box>
    <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>

    </Container>

    <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
      <HashLink className='navItemHero' smooth to="/#leistungen">Leistungen</HashLink>
      <HashLink className='navItemHero' smooth to="/#notare">Notare</HashLink>
      <HashLink className='navItemHero' smooth to="/team">Team</HashLink>
      <HashLink className='navItemHero' smooth to="#kontakt">Kontakt</HashLink>
      <HashLink className='navItemHero flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
    </Box>

    {/* <div className="heroCTAWrapper">
      <Button href="#" target='_blank' variant='contained' className='mandantenCTATop'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
    </div> */}
  </Box>


  <Box className="mainWrapper">

    <Container maxWidth="lg" className="subPageContainerThin">

      <HashLink className='breadcrumb' smooth to="/#leistungen">Leistungen</HashLink>
            <Typography variant='h1' className='subTitle'>Vereine</Typography>


      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Verein gründen</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
     Einen Verein müssen mindestens sieben Personen gründen. Die Satzung des Vereins können sie schriftlich schließen. Anschließend reicht der Vorstand die Anmeldung zum Vereinsregister über einen Notar beim zuständigen Amtsgericht ein. Bitte stimmen Sie unbedingt den Entwurf der Satzung vor der Gründungsversammlung mit dem Finanzamt ab. Denn häufig beanstandet das Vereinsregister einzelne Satzungsbestimmungen. Außerdem muss die Satzung bestimmen Anforderungen genügen, damit das Finanzamt dem Verein den Status der Gemeinnützigkeit verleihen wird.
     </Typography>
     <Button className='btnSecondary'><HashLink smooth to="https://dialog.ht-notare.de/registeredassociation/founding">Verein gründen Formular</HashLink></Button>
        </Box>
      </Box>

      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Vereinsvorstand wechseln</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
     Wechselt der Vereinsvorstand, muss diese Änderung in das Vereinsregister eingetragen werden. Der Notar bereitet die entsprechende Anmeldung zum Vereinsregister vor und lässt den neuen Vorstand die Anmeldung unterschreiben.
     </Typography>
     <Button className='btnSecondary'><HashLink smooth to="https://dialog.ht-notare.de/registeredassociation/change">Verein ändern Formular</HashLink></Button>
        </Box>
      </Box>

    </Container>


                      <Box className="map" id="map">
                          <Box className="contactMap">
                              <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe>

                          </Box>

                      </Box>



    <Box className="section bannergrey" id="kontakt">
      <Container maxWidth="lg" className="container" id="kontakt">
        <Box className="kontaktGrid">
          <Box className="kontaktLeftSide">
            <Typography variant='h2' className='sectionTitle white'>
              Sie haben Fragen?  <br />
              Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
            </Typography>
            <Typography variant='body1' paragraph className='whiteText'>
              Harbecke & Thelen Notare<br />
              Holzgasse 29 - 33<br />
              Siegburg 53721<br />
            </Typography>
          </Box>
          <Contactform />
        </Box>
      </Container>
    </Box>

  </Box>

</main >
<Footer />
    </div >
  );
};

export default ScrollAnimation;